import type { FC } from "react"

import ConfirmationDialog from "./ConfirmationDialog"

interface CancelDialogProps {
  title?: string
  message?: string
  closeLabel?: string
  confirmLabel?: string
  onClose: () => void
  onConfirm: () => void
}

const CancelDialog: FC<CancelDialogProps> = ({
  onConfirm,
  onClose,
  title = "Oh no! Are you sure you want to cancel?",
  message = "By cancelling now, your information will not be saved. Click on “Go Back” if this action was a mistake.",
  closeLabel = "Go Back",
  confirmLabel = "Yes, Cancel",
}) => {
  return (
    <ConfirmationDialog
      title={title}
      content={message}
      closeLabel={closeLabel}
      confirmLabel={confirmLabel}
      isWarning={true}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  )
}

export default CancelDialog
